// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8642) return "static/chunks/8642-b792670e28402727.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2538 ? "c8e26dd5" : chunkId) + "." + {"1715":"e8f833ea462f0df8","2538":"e280ec3816cc3637","3469":"a405c82d672779c3","3490":"61f31c07f1108133","4127":"6920b3d3e71b98ea","4253":"f2c888d372cd5644","4307":"7f4edab1a91cca42","6353":"db012a4c7c1271cb","9838":"84f1fa8cd9dbc21b"}[chunkId] + ".js";
};